module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i4jWX"))).then(() => parcelRequire('1iHdE'));